import React from 'react';
import PropTypes from 'prop-types';
import { FDLabelText, FDStack } from '@facet-wealth/design';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { Text } from 'Packages/FacetDesign/Components/Text';
import { PercentInputSmall } from 'Packages/FacetDesign/Components';
import {
  BeneficiaryTypeInput,
} from 'Views/Page/Content/Templates/AccountOpeningV2BeneficiaryAllocationsStep/BeneficiaryTypeInput';
import { dataAttrs } from 'Helpers/Testing';

const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('name', {
    _component: () => Text,
    _customProps: { Component: FDLabelText, size: 'md' },
  }, overrideReadOnly)
  .nameOverride('sharePercentage', {
    _component: () => PercentInputSmall,
  }, overrideReadOnly)
  .nameOverride('beneficiaryType', {
    _component: () => BeneficiaryTypeInput,
  }, overrideReadOnly);

export const BeneficiaryAllocation = ({
  resource, resourceIdx, onChange, remaining,
}) => {
  return (
    <FDStack direction={'column'} spacing={1} {...dataAttrs('beneficiary-allocation', resource)}>
      <MetaControl resource={resource} attrName={'name'} metaOverrideSet={metaOverrideSet} />
      <MetaControl
        resource={resource}
        attrName={'sharePercentage'}
        metaOverrideSet={metaOverrideSet}
        onChange={(val) => {
          const numVal = +val;
          const actual = numVal > remaining ? remaining : numVal;
          onChange(resource.attr('sharePercentage', `${actual}`), resourceIdx);
        }}
      />
      <MetaControl
        resource={resource}
        attrName={'beneficiaryType'}
        metaOverrideSet={metaOverrideSet}
        onChange={(val) => {
          onChange(resource.attr('beneficiaryType', val), resourceIdx);
        }}
      />
    </FDStack>
  );
};

BeneficiaryAllocation.propTypes = {
  resource: PropTypes.object.isRequired,
  resourceIdx: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  remaining: PropTypes.number.isRequired,
};
